var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFerry1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workspace"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 24,
    width: 24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "7 15 7 11 19 11 17 15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12,
    x2: 19,
    y1: 15,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5,
    x2: 10,
    y1: 15,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7,
    x2: 13,
    y1: 17,
    y2: 17
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "10 9 10 6 13 6 13 9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16,
    x2: 16,
    y1: 13,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14,
    x2: 14,
    y1: 13,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12,
    x2: 12,
    y1: 13,
    y2: 13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "9 11 9 9 15 9 16 11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15,
    x2: 17,
    y1: 17,
    y2: 17
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerry1);
export default __webpack_public_path__ + "static/media/ferry-1.a40db69fa745a120685ece1180927555.svg";
export { ForwardRef as ReactComponent };